module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fc-Hc-Ia.cefb0d24.png";